import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "../assets/css/components/module-card.css"
import generalBackground from "../assets/img/modules/General_Module_Web.png"
import ecoBackground from "../assets/img/modules/Ecology_Module_Web.jpg"
import heredityBackground from "../assets/img/modules/Heredity_Module_Web.jpg"
import cellsBackground from "../assets/img/modules/Cells_Module_Web.png"
import weatherBackground from "../assets/img/modules/Weather_And_Climate.png"
import earthsStyemsBackground from "../assets/img/modules/Earths_Systems_Module.png"
import grade6Math2Background from "../assets/img/modules/Math_Module.png"
import {
  faCloudSunRain,
  faGlobe,
  faLeaf,
  faDna,
  faUsers,
  faChartSimple,
  faGears,
  faVolcano,
  faGear,
  faHand
} from "@fortawesome/free-solid-svg-icons"
library.add(
  faGlobe,
  faCloudSunRain,
  faLeaf,
  faDna,
  faUsers,
  faChartSimple,
  faGears,
  faVolcano,
  faGear,
  faHand
)

const ModuleCard = ({ title, id }) => {
  const configFor = moduleId => {
    switch (parseInt(moduleId, 10)) {
      case 1:
        // Ecology
        return {
          subtitle: "Save animals, tour the biodomes, and build your very own ecosystem!",
          icon: faLeaf,
          image: ecoBackground
        }
      case 2:
        // Growth & Genetics & Natural Selection
        return {
          subtitle:
            "Explore the many ways that genes are inherited to produce differences between parents and children, as well as dramatic, species-level changes that occur slowly over time!",
          icon: faDna,
          image: heredityBackground
        }
      case 3:
        // General
        return {
          subtitle: "Develop your skills as a scientist!",
          icon: faHand,
          image: generalBackground
        }
      case 4:
        // id=4 somehow got skipped over in the CAT
        return {}
      case 5:
        // Cells to Organisms
        return {
          subtitle: "Assist in the community clinic to solve medical mysteries!",
          icon: faGear,
          image: cellsBackground
        }
      case 6:
        // Weather and Climate
        return {
          subtitle: "Learn how weather affects local areas, continents, and the entire planet!",
          icon: faCloudSunRain,
          image: weatherBackground
        }
      case 10:
        // Math
        return {
          subtitle: `Find solutions to problems in engineering, animal healthcare, and social activism using mathematics! (Inequalities, algebra, expressions and equations, and measures of center are covered in this module.)`,
          icon: faChartSimple,
          image: grade6Math2Background
        }
      case 11:
        // Earth Science
        return {
          subtitle: `Learn how the Earth's planetary structure can move mountains, cause earthquakes, and create every rock and mineral from diamond to basalt! `,
          icon: faVolcano,
          image: earthsStyemsBackground
        }
      default:
        return {}
    }
  }

  return (
    <div className='col-sm-12 col-md-6 col-lg-3 m-b-10 module-card'>
      <div className='ar-1-1'>
        <div
          style={{ backgroundImage: `url(${configFor(id).image})` }}
          className='card no-border bg-primary widget widget-loader-circle-lg no-margin'
        >
          <Link to={`/modules/${id}`} className='ab-link'></Link>
          <div className='card-block'>
            {configFor(id).icon && (
              <span className='label font-montserrat'>
                <FontAwesomeIcon icon={configFor(id).icon} />
              </span>
            )}
            <div className='pull-bottom bottom-left bottom-right padding-25'>
              <br />
              <h3 className='text-white'>{title}</h3>
              {configFor(id).subtitle && (
                <p className='text-white hint-text hidden-lg-down'>{configFor(id).subtitle}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const { string } = PropTypes
ModuleCard.propTypes = {
  title: string.isRequired,
  id: string.isRequired
}

export default ModuleCard
